var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.5V1.75C5.25 1.41848 5.3817 1.10054 5.61612 0.866116C5.85054 0.631696 6.16848 0.5 6.5 0.5H21.5C21.8315 0.5 22.1495 0.631696 22.3839 0.866116C22.6183 1.10054 22.75 1.41848 22.75 1.75V19.25C22.75 19.5815 22.6183 19.8995 22.3839 20.1339C22.1495 20.3683 21.8315 20.5 21.5 20.5H17.75V24.25C17.75 24.94 17.1875 25.5 16.4912 25.5H1.50875C1.34391 25.501 1.1805 25.4694 1.0279 25.407C0.875309 25.3447 0.736542 25.2528 0.619573 25.1366C0.502605 25.0205 0.409741 24.8823 0.346318 24.7302C0.282894 24.578 0.250162 24.4148 0.25 24.25L0.25375 6.75C0.25375 6.06 0.81625 5.5 1.5125 5.5H5.25ZM2.75375 8L2.75 23H15.25V8H2.75375ZM7.75 5.5H17.75V18H20.25V3H7.75V5.5Z",
    fill: "#3C1FAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copyLink.fd6f4f9b2b4930de5725e5c92b0fa809.svg";
export { ForwardRef as ReactComponent };